"use strict";

exports.__esModule = true;
exports.convertDateToRfcStartOfDay = exports.TimeUnits = void 0;
exports.convertRfcTimeToLocalDateTimeStartOfDay = convertRfcTimeToLocalDateTimeStartOfDay;
exports.getDayName = exports.getDateTimeFromLocalDateTime = exports.fromLocalDateTimeToRfc = exports.formatTimezone = exports.formatShortTime = exports.formatShortDate = exports.formatRfcTimeStringToTimeSlotView = exports.formatRfcTimeStringToDateAndTimeView = exports.formatMonth = exports.formatLocalDateTimeToWeekday = exports.formatLocalDateTimeToShortWeekday = exports.formatLocalDateTimeToDay = exports.formatLocalDateTimeToDateView = exports.differencesBetweenTwoDates = void 0;
exports.getEndOfDayFromLocalDate = getEndOfDayFromLocalDate;
exports.getEndOfDayFromLocalDateTime = getEndOfDayFromLocalDateTime;
exports.getEndOfMonthAsLocalDateTime = getEndOfMonthAsLocalDateTime;
exports.getLocalTimezone = exports.getLocalDateTimeStartOfDay = exports.getLocalDateTimeEndOfDay = exports.getLocalDateFromDateTime = void 0;
exports.getStartOfMonthAsLocalDateTime = getStartOfMonthAsLocalDateTime;
exports.getStartOfNextDateLocalDateTime = getStartOfNextDateLocalDateTime;
exports.getTodayLocalDateTimeStartOfDay = getTodayLocalDateTimeStartOfDay;
exports.getWeekRange = void 0;
exports.isMonthDifferent = isMonthDifferent;
exports.isSameDay = void 0;
exports.isWeekDifferent = isWeekDifferent;
var _bookingsDateTime = require("@wix/bookings-date-time");
var _weekStart = require("./weekStart");
exports.getFirstDayOfTheWeek = _weekStart.getFirstDayOfTheWeek;
var _dateUtils = require("wix-ui-tpa/date-utils");
const getLocalTimezone = () => {
  return new Intl.DateTimeFormat().resolvedOptions().timeZone;
};

// example - return 2020-10-05T00:00:00
exports.getLocalTimezone = getLocalTimezone;
const getLocalDateTimeStartOfDay = date => {
  const localDate = getLocalDateFromDateTime(date);
  return `${localDate}T00:00:00`;
};

// example - return 2020-10-05T23:59:59
exports.getLocalDateTimeStartOfDay = getLocalDateTimeStartOfDay;
const getLocalDateTimeEndOfDay = date => {
  const localDate = getLocalDateFromDateTime(date);
  return getEndOfDayFromLocalDate(localDate);
};
exports.getLocalDateTimeEndOfDay = getLocalDateTimeEndOfDay;
const convertDateToRfcStartOfDay = date => {
  const localDate = getLocalDateFromDateTime(date);
  return `${localDate}T00:00:00.000Z`;
};
exports.convertDateToRfcStartOfDay = convertDateToRfcStartOfDay;
const getLocalDateFromDateTime = date => {
  const addZero = num => num < 10 ? `0${num}` : `${num}`;
  return `${date.getFullYear()}-${addZero(date.getMonth() + 1)}-${addZero(date.getDate())}`;
};
exports.getLocalDateFromDateTime = getLocalDateFromDateTime;
const getDateTimeFromLocalDateTime = localDateTime => (0, _bookingsDateTime.rfcToShiftedDate)(localDateTime);
exports.getDateTimeFromLocalDateTime = getDateTimeFromLocalDateTime;
const formatLocalDateTimeToDateView = (localDateTime, locale) => new _bookingsDateTime.DateTimeFormatter(locale).formatDayOfMonth(localDateTime);
exports.formatLocalDateTimeToDateView = formatLocalDateTimeToDateView;
const formatRfcTimeStringToTimeSlotView = (rfcTime, locale) => new _bookingsDateTime.DateTimeFormatter(locale).formatTime(rfcTime);
exports.formatRfcTimeStringToTimeSlotView = formatRfcTimeStringToTimeSlotView;
const formatLocalDateTimeToDay = (localDateTime, locale) => new _bookingsDateTime.DateTimeFormatter(locale).formatDay(localDateTime);
exports.formatLocalDateTimeToDay = formatLocalDateTimeToDay;
const formatLocalDateTimeToShortWeekday = (localDateTime, locale) => new _bookingsDateTime.DateTimeFormatter(locale).formatShortWeekday(localDateTime);
exports.formatLocalDateTimeToShortWeekday = formatLocalDateTimeToShortWeekday;
const formatLocalDateTimeToWeekday = (localDateTime, locale) => new _bookingsDateTime.DateTimeFormatter(locale).formatWeekday(localDateTime);
exports.formatLocalDateTimeToWeekday = formatLocalDateTimeToWeekday;
const formatMonth = (dateString, locale) => new _bookingsDateTime.DateTimeFormatter(locale).formatMonth(dateString);
exports.formatMonth = formatMonth;
const formatShortDate = (dateString, locale, timezone) => new _bookingsDateTime.DateTimeFormatter(locale, timezone).formatShortDate(dateString);
exports.formatShortDate = formatShortDate;
const formatShortTime = (dateString, locale, timezone) => new _bookingsDateTime.DateTimeFormatter(locale, timezone).formatTime(dateString);
exports.formatShortTime = formatShortTime;
const formatRfcTimeStringToDateAndTimeView = (rfcTime, locale) => new _bookingsDateTime.DateTimeFormatter(locale).formatDateAndTime(rfcTime);
exports.formatRfcTimeStringToDateAndTimeView = formatRfcTimeStringToDateAndTimeView;
let TimeUnits = exports.TimeUnits = /*#__PURE__*/function (TimeUnits) {
  TimeUnits["day"] = "day";
  TimeUnits["minute"] = "minute";
  return TimeUnits;
}({});
const differencesBetweenTwoDates = (rfcStartTime, rfcEndTime, timeUnits) => {
  const secondsInDay = 86400;
  const minutesInHour = 60;
  const hoursInDay = 24;
  const minutesInDay = minutesInHour * hoursInDay;
  const delta = Math.abs(new Date(rfcStartTime).getTime() - new Date(rfcEndTime).getTime()) / 1000;
  const days = Math.floor(delta / secondsInDay);
  if (timeUnits === TimeUnits.day) {
    return days;
  }
  const hours = Math.floor(delta / (minutesInHour * minutesInHour)) % hoursInDay;
  const minutes = Math.floor(delta / minutesInHour) % minutesInHour;
  return minutes + hours * minutesInHour + days * minutesInDay;
};
exports.differencesBetweenTwoDates = differencesBetweenTwoDates;
function getTodayLocalDateTimeStartOfDay(timezone) {
  const dateTimeFormat = new Intl.DateTimeFormat('en-us', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: timezone
  });
  const dateString = dateTimeFormat.format(new Date());
  const shiftedDate = new Date(dateString);
  return getLocalDateTimeStartOfDay(shiftedDate);
}
function getStartOfMonthAsLocalDateTime(localDateTime) {
  const date = (0, _bookingsDateTime.rfcToShiftedDate)(localDateTime);
  date.setDate(1);
  return getLocalDateTimeStartOfDay(date);
}
function getStartOfNextDateLocalDateTime(localDateTime) {
  const date = (0, _bookingsDateTime.rfcToShiftedDate)(localDateTime);
  date.setDate(date.getDate() + 1);
  return getLocalDateTimeStartOfDay(date);
}
function getEndOfMonthAsLocalDateTime(localDateTime, monthRange) {
  const date = (0, _bookingsDateTime.rfcToShiftedDate)(localDateTime);
  const endOfMonthAsDate = new Date(date.getFullYear(), date.getMonth() + monthRange, 0);
  const endOfMonthAsLocalDate = getLocalDateFromDateTime(endOfMonthAsDate);
  return getEndOfDayFromLocalDate(endOfMonthAsLocalDate);
}
function getEndOfDayFromLocalDateTime(localDateTime) {
  const localDate = localDateTime.substr(0, localDateTime.indexOf('T'));
  return getEndOfDayFromLocalDate(localDate);
}
function getEndOfDayFromLocalDate(localDate) {
  return `${localDate}T23:59:59`;
}
function convertRfcTimeToLocalDateTimeStartOfDay(rfcTime) {
  const localDate = rfcTime.substr(0, rfcTime.indexOf('T'));
  return `${localDate}T00:00:00`;
}
function isMonthDifferent(localDateTime1, localDateTime2) {
  return (0, _bookingsDateTime.rfcToShiftedDate)(localDateTime1).getMonth() !== (0, _bookingsDateTime.rfcToShiftedDate)(localDateTime2).getMonth();
}
function isWeekDifferent(localDateTime1, localDateTime2, locale) {
  const firstDayOfTheWeek = (0, _weekStart.getFirstDayOfTheWeek)(locale);
  const firstDate = getDateTimeFromLocalDateTime(localDateTime1);
  const secondDate = getDateTimeFromLocalDateTime(localDateTime2);
  const {
    startOfWeek: startOfFirstWeek
  } = (0, _dateUtils.getWeekDatesRange)(firstDate, firstDayOfTheWeek);
  const {
    startOfWeek: startOfSecondWeek
  } = (0, _dateUtils.getWeekDatesRange)(secondDate, firstDayOfTheWeek);
  return startOfFirstWeek.getTime() !== startOfSecondWeek.getTime();
}
const getDayName = rfcDate => {
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const dayNumber = new Date(rfcDate.split('T')[0]).getDay();
  return days[dayNumber];
};
exports.getDayName = getDayName;
function getRFCOffset(localDatetime) {
  const offsetMinutes = new Date(localDatetime).getTimezoneOffset(); // Get offset in minutes
  const sign = offsetMinutes > 0 ? '-' : '+'; // Reverse sign because getTimezoneOffset() returns opposite sign
  const absMinutes = Math.abs(offsetMinutes);
  const hours = Math.floor(absMinutes / 60);
  const minutes = absMinutes % 60;
  return `${sign}${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}
const fromLocalDateTimeToRfc = localDatetime => {
  // const minutes = new Date(localDatetime).getTimezoneOffset();
  const offset = getRFCOffset(localDatetime);
  // Construct RFC format
  return `${localDatetime}${offset}`;
};
exports.fromLocalDateTimeToRfc = fromLocalDateTimeToRfc;
const formatTimezone = ({
  date,
  timezone,
  locale,
  // eslint-disable-next-line no-template-curly-in-string
  template = '${timezoneName} (${offset})'
}) => {
  var _Intl$DateTimeFormat$, _Intl$DateTimeFormat$2;
  const offset = ((_Intl$DateTimeFormat$ = Intl.DateTimeFormat(locale, {
    year: 'numeric',
    timeZoneName: 'short',
    timeZone: timezone
  }).formatToParts(date).find(part => part.type === 'timeZoneName')) == null ? void 0 : _Intl$DateTimeFormat$.value) ?? '';
  const timezoneName = ((_Intl$DateTimeFormat$2 = Intl.DateTimeFormat(locale, {
    year: 'numeric',
    timeZoneName: 'long',
    timeZone: timezone
  }).formatToParts(date).find(part => part.type === 'timeZoneName')) == null ? void 0 : _Intl$DateTimeFormat$2.value) ?? '';
  return Function('timezoneName', 'offset', `return \`${template}\`;`)(timezoneName, offset);
};
exports.formatTimezone = formatTimezone;
const getWeekRange = (date, firstDayOfTheWeek) => {
  const dayOfWeek = date.getDay(); // 0 (Sunday) to 6 (Saturday)
  const diffToFirstDay = (dayOfWeek - firstDayOfTheWeek + 7) % 7; // Calculate difference to the first day of the week
  const diffToLastDay = (firstDayOfTheWeek - dayOfWeek + 6) % 7; // Calculate difference to the last day of the week

  const startOfWeek = new Date(date);
  const endOfWeek = new Date(date);

  // Adjust startOfWeek to the first day of the week
  startOfWeek.setDate(date.getDate() - diffToFirstDay);
  startOfWeek.setHours(0, 0, 0, 0);

  // Adjust endOfWeek to the last day of the week
  endOfWeek.setDate(date.getDate() + diffToLastDay);
  endOfWeek.setHours(23, 59, 59, 999);
  return {
    startOfWeek,
    endOfWeek
  };
};
exports.getWeekRange = getWeekRange;
const isSameDay = (date1, date2) => {
  return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
};
exports.isSameDay = isSameDay;
//# sourceMappingURL=dateAndTime.js.map